import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../../ampli';
import { Icon } from '../../../../components/common/icon/Icon';
import { ownTractorPageInfo, pageInfo, sellTractorPageInfo } from '../../../../constants/pageInfo/pageInfo.constant';
import { useRedirectToStoredPage } from '../../../../hooks/page/useRedirectToStoredPage';
import { useLayout } from '../../../../hooks/screen/useLayout';
import { useAppDispatch } from '../../../../hooks/store/useStore';
import { userOwnTractorSurveySlice } from '../../../../store/userOwnTractorSurveySlice';
import { browserStorage } from '../../../../utils/browserStorage.util';
import { Button } from '../../../../components/common/buttons/Button';

export const OwnTractorSurveyCompletePage = () => {
  const navigate = useNavigate();

  useLayout({
    fixedHeader: <></>,
    fixedHeaderHeight: 0,
    fixedFooter: (
      <ButtonContainer>
        <Button
          borderType={'square'}
          color={'filledPrimaryStrong'}
          size={'md'}
          text={{ size: 'md', content: '사진 등록할게요' }}
          onClick={() => {
            ampli.pvmEnterOwnTractorImageUploadPage({ from: 'own_tractor_complete_page' });
            navigate(ownTractorPageInfo.imageUploadPage.path, { replace: true });
          }}
        />
        <Button
          borderType={'square'}
          color={'filledGreyLight'}
          size={'md'}
          text={{ size: 'md', content: '보유트랙터 관리로 가기' }}
          onClick={() => {
            ampli.pvmClickOwnTractorImageUploadLater();
            navigate(pageInfo.myInfoOwnTractorListPage.path, { replace: true });
          }}
        />
      </ButtonContainer>
    ),
    fixedFooterHeight: 120,
    shouldShowFooter: false,
  });

  return (
    <Container>
      <MainSection>
        <Icon name={'Celebration2'} width={150} height={150} />

        <TextContainer>
          <BigText>{'트랙터 등록이 완료되었습니다!'}</BigText>
          <SmallText>{'사진 등록하면, 더 많은 관심과\n가격 제안을 받을 수 있어요!'}</SmallText>
        </TextContainer>
        <GreyChip>
          <GreyChipText>{'예상 참여 시간'}</GreyChipText>
          <GreenChip>
            <GreenChipText>{'1분 내외'}</GreenChipText>
          </GreenChip>
        </GreyChip>
      </MainSection>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 120px);

  padding: 24px 24px 32px 24px;

  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 32px;
`;

const MainSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  flex: 1 0 0;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);
`;

const BigText = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
`;

const SmallText = styled.pre`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);
  text-align: center;

  /* Body/Large/l-light */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 150%; /* 24px */
`;

const ButtonContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background-color: white;

  padding: 0px 16px 32px 16px;

  gap: 8px;
`;

const GreyChip = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: var(--radius-medium, 8px) var(--radius-large, 16px);
  gap: var(--radius-medium, 8px);

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const GreyChipText = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);
  text-align: center;

  /* Display/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 18.2px */
`;

const GreenChip = styled.div`
  display: flex;
  align-items: center;

  padding: 6px 8px;

  gap: 2px;

  border-radius: var(--radius-small, 4px);
  background: var(--Light-Scheme-Color-primary-green, #34c77e);
`;

const GreenChipText = styled.div`
  color: var(--Light-Scheme-Monochrome-white, #fff);
  text-align: center;

  /* System/Small/s-medium */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 10.2px */
`;
